import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useUpdateProject } from "@/entities/project";
import { getLocationSelectOptionValue } from "@/modules/location/location-select-parent";
import { getOrganizationSelectOptionValue } from "@/modules/organization/organization-select";
import { parseDate } from "@/utilities/date";

import ProjectForm from "../ProjectForm";

const ProjectEdit = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useUpdateProject(model.id);
  const saveButtonLabel = t("global:update");

  const initialValues = {
    name: model.name,
    reference: model.reference,
    description: model.description,
    users: model.users?.map(({ id, name, email }) => ({
      value: id,
      label: `${name} (${email})`,
    })),
    start_date: parseDate(model.start_date),
    due_date: parseDate(model.due_date),
    organization: getOrganizationSelectOptionValue(model.ancestors),
    location: getLocationSelectOptionValue(model.ancestors),
    revised_interventions_cost: model.revised_interventions_cost,
  };

  return (
    <ProjectForm
      model={model}
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
    />
  );
};

ProjectEdit.propTypes = {
  model: PropTypes.object,
};

export default ProjectEdit;
